import React, { useState, useEffect } from "react";
import DetallesPlanCosechaEntrada from "./DetallesPlanCosechaEntrada";
import HistorialEstados from "./HistorialEstados";
import { PHP_API } from "../../utils/Common";
import axios from "axios";
import EntregaPlanPDF from "../templates/EntregaPlanPDF";
import detalles from '../../assets/detalles.png';
import historial from '../../assets/history.png';

const EntregaEstado = (props) => {
   const concluir = props.concluir;
   const [planes, setplanes] = useState([...props.data]);
   const [idDetalles, setidDetalles] = useState();
   const [modif, setmodif] = useState([]);
   const [showHistory, setshowHistory] = useState(false);
   const [loader, setloader] = useState(false);
   const [history, sethistory] = useState([]);
   const [pdf, setpdf] = useState(false);


   useEffect(() => {
      prepararModif();
   }, []);

   const abrirHistorial = (id) => {
      setloader(true);
      axios.post(`${PHP_API}HistorialEstatusvivero`, { id: id, estatus: 2 }).then((resp) => {
         setloader(false);
         sethistory([...resp.data]);
         setshowHistory(true);
      }).catch((e) => { setloader(false) })

   }

   const mostrar_ocultar_detalles = (id) => {
      if (!id || idDetalles == id) setidDetalles(-1);
      else setidDetalles(id);
   }

   const verificaractualizar = () => {
      let nuevas = [...props.data];
      if (nuevas.length != planes.length) return true;
      for (let i = 0; i < nuevas.length; i++) {
         if (nuevas[i].id != planes[i].id || nuevas[i].aclimatacionCantidad != planes[i].aclimatacionCantidad || nuevas[i].total_entregado != planes[i].total_entregado) return true;
      }
      return false;
   }

   const actualizar = () => {
      if (verificaractualizar()) {
         for (let i = 0; i < planes.length; i++) {
            let inp = document.getElementById(`input${i}`);
            if (inp) inp.value = 0;
         }
         setplanes([...props.data]);
         prepararModif();
      }
   }

   const prepararModif = () => {
      let dat = props.data ?? [];
      let modify = [];
      for (let i = 0; i < dat.length; i++) {
         modify.push({
            aclimatacionCantidad: dat[i].aclimatacionCantidad,
            modif: 0,
            error: false
         });
      }
      setmodif(modify);
   }

   const agregarValor = (i, valor) => {
      let modify = [...modif];
      let pl = [...planes];

      modify[i].modif = (valor == '') ? 0 : parseFloat(valor);
      modify[i].error = detectarErrores(pl[i], (valor == '') ? 0 : parseFloat(valor), modify[i].aclimatacionCantidad ?? 0);
      pl[i].aclimatacionCantidad = modify[i].modif + modify[i].aclimatacionCantidad;


      if (puedoSubir(modify)) {
         props.save(true, modify);
         setplanes([...pl]);
      } else {
         props.save(false, []);
         setplanes([...pl]);
      }
   }

   const marcar_terminado_clase = (val) => {
      let ejecutado = val.plantas_total_ejecutado,
         inventario = val.total_aclimatacion,
         entregadas = val.total_entregado;
      if (inventario <= 0 ||
         ejecutado <= 0 ||
         (inventario / ejecutado) < .9 ||
         (inventario - entregadas) > 1) return 'text-center text-s nowrap';

      return 'text-blue3 text-bold text-center nowrap';
   }

   //Verifica que el valor que se trata de agregar +  e;l valor del estado anterior no sea menor ni mayior a la suma de este
   const detectarErrores = (original, agregado, anterior) => {
      if (original.germinacion_real <= 0 || original.germinacion_envio <= 0) return "La germinación real y de envio deben ser superior a cero para poder agregar cantidades";

      //Primero convertimos las charolas de aclimatacionn al numero de plantas equivalentes
      let a_ingresar = agregado * original.germinacion_envio * 288;

      //Verificar que la nueva cantidad no vuelva el valor de ingreso a simebra menor a cero
      let suma = original.total_entregado + a_ingresar;
      if (suma < 0) return `El total en entrega no puede ser inferior a cero`;
      console.log(suma, original.total_entregado, original);
      let incertudumbre = original.germinacion_real * 288 * 5; //se permite 1/4 de charola de inscertidumbre al entegar
      //Verificar que lo que entra a aclimatación no sea mayor a los que se sembró
      if ((original.total_aclimatacion - suma) < -incertudumbre) return 'No se pueden reportar mas charolas entregadas que las reportadas en aclimatación';

      return false;
   }

   //detecta si existe algun error que impida activar el boton se subida
   const errorExiste = (modifs) => {
      for (let i = 0; i < modifs.length; i++)
         if (modifs[i].error) return true;
      return false;
   }

   //Deteecta si existe algun cambio y que no existan errores para activar el boton de subida
   const puedoSubir = (modify) => {
      if (errorExiste(modify)) return false;
      for (let j = 0; j < modify.length; j++) {
         if (modify[j].modif != 0) return true;
      }
      return false;
   }

   const mostrarHistorial = (id) => {
      setshowHistory(true);
      abrirHistorial(id);
   }

   actualizar();
   const separador = () => { return (<span className="ms-2 me-2 text-900" style={{ color: "#BBBBBB" }}>|</span>) }

   /**
    * Retorna las diferencias en semanas entre la semana de siembra planeada y la semana de ejecución
    * @param {object} p - un elemento del plan de siembra de la lista alojada en data
    * @returns {number} numero de semanas de diferencia respecto a semana de siembra planeada
    */
   const diferencia = (p) => {
      if (p.semana_ejecucion && p.fecha_inicio) {
         let inicio = new Date(p.fecha_inicio);
         let ejecucion = new Date(p.fecha_semana_ejecucion);

         let diferencia = ejecucion - inicio;
         let dias = diferencia / (1000 * 60 * 60 * 24);
         let semanas = dias / 7;
         return Math.floor(semanas);
      }
      return 0;
   }

   return (
      <div className="col-lg-12 m-0 p-1 pt-0 dosis" style={{ overflow: 'auto', maxHeight: "88vh" }}>
         <table className="table table-sm table-hover table-bordered">
            <thead className="bg-orange-900 text-white mt-0 pt-0">
               <tr >
                  <th className='text-center nowrap'>Información</th>
                  <th className="text-center nowrap">Flor variedad color</th>
                  <th className="text-center nowrap text-s">Sem. siembra </th>
                  <th className="text-center nowrap text-s">Sem. ejecución</th>
                  <th className="text-center nowrap text-s">Sem. Transplante</th>
                  <th className="text-center nowrap p-0 m-0">
                     <div className='col-lg-12 p-0 m-0 text-center ps-2 pe-2'>
                        <p className="p-0 m-0 text-s">Plan de siembra</p>
                        <p className="p-0 m-0 text-xs text-bold">Plantas{separador()}charolas{separador()}Gm. programa</p>
                     </div>
                  </th>

                  <th className="text-center nowrap p-0 m-0">
                     <div className='col-lg-12 p-0 m-0 text-center ps-2 pe-2'>
                        <p className="p-0 m-0 text-s">Germinación Monitoreada</p>
                        <p className="p-0 m-0 text-xs text-bold">Plantas{separador()}Charolas{separador()}Gm. DDS</p>
                     </div>
                  </th>

                  <th className="text-center nowrap p-0 m-0">
                     <div className='col-lg-12 p-0 m-0 text-center ps-2 pe-2'>
                        <p className="p-0 m-0 text-s">Entregado A Campo</p>
                        <p className="p-0 m-0 text-xs text-bold">Plantas{separador()}Charolas{separador()}Gm. consolidación</p>
                     </div>
                  </th>
                  <th className="text-center nowrap p-0 m-0">
                     <div className='col-lg-12 p-0 m-0 text-center ps-2 pe-2'>
                        <p className="p-0 m-0 text-s">Faltanta entregar</p>
                        <p className="p-0 m-0 text-xs text-bold">Plantas{separador()}Charolas{separador()}Gm. consolidación</p>
                     </div>
                  </th>
                  <th className='text-center text-s nowrap'>Marcar como entregado</th>
                  {/*<th className='text-center text-s nowrap'>Gm. entrega</th>
                  <th className='text-center text-s nowrap'>Entregar charolas</th>*/}
               </tr>
            </thead>
            <tbody>
               {planes.map((p, i) => {
                  return (
                     <React.Fragment key={i + "kmfiklmwfl;werf"} >
                        <tr className="text-danger" >
                           <td className="text-center contenedor" style={{ width: "100px" }}>
                              <div className='row justify-content-evenly w-100 m-0 p-0'>
                                 <img src={detalles} className="pointer scale-1" style={{ height: "18px", width: "auto" }}
                                    title="Mostrar historial de cambios"
                                    onClick={() => { mostrar_ocultar_detalles(p.id) }} />
                                 <img src={historial} className={`${p.aclimatacionEntradas && p.aclimatacionEntradas > 0 ? " pointer scale-1" : " opacity-40"}`}
                                    style={{ height: "18px", width: "auto" }}
                                    title="Detalles del registro"
                                    onClick={() => {
                                       if (!p.aclimatacionEntradas || p.aclimatacionEntradas <= 0) return;
                                       mostrarHistorial(p.id);
                                    }} />

                              </div>
                              {/*<button className='btn btn-sm round-xxs btn-light shadow scale-1 m-0 pt-0 pb-0' onClick={() => { mostrar_ocultar_detalles(p.id) }}>Detalles</button>*/}
                           </td>
                           <td className="text-center nowrap text-s">
                              <p className={`${p.completo === 1 ? 'text-success' : 'text-floricents'} text-bold`}>{p.bloque}</p>
                           </td>
                           <td className={marcar_terminado_clase(p)}>{p.semanainicio}</td>
                           <td className={marcar_terminado_clase(p) + (diferencia(p) > 0 ? " rosa-restrasado" : "")}>{p.semana_ejecucion ?? "--"}</td>
                           <td className={marcar_terminado_clase(p)}>{p.transplante}</td>
                           <td className=" text-300 bw-200 text-s text-center">
                              {Math.floor(+p.plantas)}{separador()}{Math.floor(+p.charolas)}{separador()}{p.por_germinacion}%
                           </td>
                           <td className={marcar_terminado_clase(p)}>{Math.floor(p.total_aclimatacion)}{separador()}{Math.floor(p.charolas_germinadas)}{separador()}{p.germinacion_real}%</td>
                           <td className={marcar_terminado_clase(p)}> {Math.floor(p.total_entregado)}{separador()}{Math.floor(p.charolas_entregado)}{separador()}{p.germinacion_envio}%</td>
                           <td className={marcar_terminado_clase(p)}>
                              {p.germinacion_envio <= 0 ? 0 : Math.abs(Math.floor(p.total_aclimatacion - p.total_entregado))}{separador()}
                              {p.germinacion_envio <= 0 ? 0 : Math.abs(Math.floor((p.total_aclimatacion - p.total_entregado) / 288 / p.germinacion_envio))}{separador()}
                              {p.germinacion_envio}%
                           </td>

                           {/*<td className=" nowrap text-xs p-0">
                              <div className='col-lg-12 m-0 p-1 contenedor'>
                                 <input
                                    id={i}
                                    className="form-control form-control-sm text-center p-0 m-0"
                                    type="number"
                                    step="any"
                                    name="germinacion_envio"
                                    placeholder={p.germinacion_envio}
                                    onChange={(e) => { props.cambiarGermiancion(e.target.value, i, 'germinacion_envio'); }} />
                              </div>
                           </td>

                           <td className='col-auto p-1 m-0 text-center'>
                              <input type='number' className='form-control form-control-sm m-0 p-0' onChange={(e) => { agregarValor(i, e.target.value) }} id={`input${i}`} disabled={p.germinacion_envio <= 0} />
                           </td>*/}
                           <td className="contenedor">
                              <button className='btn btn-sm scale-05 btn-dark border border-danger shadow m-0 ps-5 pe-5 pt-0 pb-0' onClick={() => concluir(p.id)} >Concluir</button>
                           </td>
                        </tr>

                        {idDetalles == p.id && <DetallesPlanCosechaEntrada key={i + "indexEdicionD"} data={p} index={i} close={mostrar_ocultar_detalles} span={11} />}
                        {modif[i] && modif[i].error && <tr className='p-0 m-0'>
                           <td key={i + "indexEdicionDDD"} className='text-center text-danger text-s pt-0 pb-3 m-0' colSpan="11">{modif[i].error}</td>
                        </tr>}
                     </React.Fragment>
                  );
               })}
            </tbody>
         </table>
         {showHistory && <HistorialEstados cerrar={() => { setshowHistory(false); sethistory([]); }} data={[...history]} />}
         {loader && <div className="frontal-blur-transparent"> <div className="loader"></div></div>}
         {pdf && <EntregaPlanPDF data={planes} loader={setloader} close={() => { setpdf(false) }} />}
      </div>
   )
}
export default EntregaEstado;